import { createClient } from "@supabase/supabase-js"
// TODO: move env vars from core to project level
type EnvVars = {
  VITE_PUBLIC_SUPABASE_URL: string
  VITE_PUBLIC_SUPABASE_ANON_KEY: string
  VITE_PUBLIC_VERSION: string
  VITE_PUBLIC_ENV: string
}

const getEnvVar = (key: keyof EnvVars): string => {
  const env = import.meta.env as unknown as EnvVars
  const value = env[key]
  if (typeof value !== "string") {
    throw new Error(`Environment variable ${key} is not a string`)
  }
  return value
}

export const instanceUrl = getEnvVar("VITE_PUBLIC_SUPABASE_URL")
export const apiKey = getEnvVar("VITE_PUBLIC_SUPABASE_ANON_KEY")
export const version = getEnvVar("VITE_PUBLIC_VERSION")
export const env = getEnvVar("VITE_PUBLIC_ENV")
export const supabaseClient = createClient(instanceUrl, apiKey)
